import { z } from 'zod'
import { oc } from '@orpc/contract'
import { actorOverrideSchema, threadPathSchema } from './assistant-conversation.contract'

export const assistantCancel = oc
  .route({ method: 'POST', path: '/v2/assistant/conversations/thread/cancel' })
  .input(z.object({ threadPath: threadPathSchema, actor: actorOverrideSchema }))
  .output(
    z.object({
      cancelled: z.boolean(),
      reason: z.enum(['not_streaming', 'busy']).optional(),
    }),
  )
